// types
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  page: false,
  comp: false,
};

// ==============================|| SLICE - MENU ||============================== //

const loading = createSlice({
  name: "loading",
  initialState,
  reducers: {
    PAGE_LOADING: (state) => {
      return {
        ...state,
        page: true,
      };
    },
    COMP_LOADING: (state) => {
      return {
        ...state,
        comp: true,
      };
    },
    RESET_LOADING: (state) => {
      return {
        page: false,
        comp: false,
      };
    },
  },
});

export default loading.reducer;

export const { PAGE_LOADING, COMP_LOADING, RESET_LOADING } = loading.actions;
